export const sessionRequestStateKey = 'request_state';
export const sessionRequestCodeVerifierKey = 'code_verifier';
export const sessionSchemeKey = 'selected_scheme';
export const sessionIdeKey = 'selected_ide';
export const sessionMachineKey = 'selected_machine';
export const sessionOrgKey = 'selected_org';
export const sessionRepoKey = 'selected_repo';
export const sessionHostKey = 'selected_host';
export const sessionServiceKey = 'selected_service';
export const sessionPatKey = 'selected_pat';
export const sessionAuthTokenKey = 'auth_token';
export const sessionEmailsSentKey = 'sent_emails';
export const sessionValidationKey = 'validation_response';
export const sessionUserTokenKey = 'user_token';
export const sessionUsernameKey = 'username';
export const sessionUserIdKey = 'user_id';
export const sessionOwnerKey = 'owner_response';

export const PAYMENT_PLANS_KEY = 'gl-pricing-state';
